import React, { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import io from "socket.io-client";
import moment from "moment";
import qs from "qs";

import {
    AiMe,
    AiMeEng,
    AiPlayer,
    AiRecommendQuestion,
    AllTabFileUpload,
    AlltabLearningMate,
    AllZip,
    ApplyReward,
    AwardWinningWorkDetail,
    BookReportAnnouncement,
    BookReportWrite,
    ClasRegTimeTable,
    ClassDetail,
    ClasUpdTimeTable,
    ExpDetail,
    Curriculum,
    EnglishLibrary,
    EnglishVocaMain,
    EnglishVocaSchedule,
    HighSchoolVoca,
    BasicVoca,
    EnglishVocaTextbook,
    EnrollSchoolCurriculumInfo,
    EvaluationReport,
    EventPop,
    ExamReportCard,
    ExcellentExamAnnouncement,
    FindId,
    FindPassword,
    InitTimeTable,
    JoinGuide,
    LicenseClassMain,
    LicenseClassSub,
    LiteratureBookReport,
    LiteratureLibrary,
    LiveQnaMain,
    Login,
    Logout,
    LugChat,
    LugInqRpl,
    LugInqWrite,
    Main,
    MidServiceResult,
    MidServiceTermInfo,
    MidTransferList,
    MyAatb,
    MyAllTabSchedule,
    MyBookReport,
    MyBookReportDetail,
    MyCalendarChg,
    MyExamInfo,
    MyExamScore,
    MyInfo,
    MyNote,
    MyNoti,
    Mypage,
    MyQnaDetail,
    MyQnaMain,
    MyQnaWrite,
    MyStudyAllTab,
    MyStudyClas,
    MyStudyPlan,
    MyStudyState,
    NotFound,
    OnlineLibraryBanner,
    PdfTest,
    PdfViewer,
    PdfViewerTest,
    PerformExamDetail,
    PerformExamMain,
    PlayerMain,
    PlayerTest,
    ReferenceRoom,
    Reward,
    ScheduleGuide,
    SchoolCourseDetail,
    SchoolCourseMain,
    ScienceEvaluationReport,
    SearchMain,
    ServiceMenu,
    SpecialClassMain,
    SpecialClassSub,
    StudyMusic,
    StudySmart,
    Studytest,
    StudyToday,
    AllNewStudyToday,
    AllNewCardGallery,
    StudyTop,
    TestZone,
    WrongAnswerNotes,
    WiseMentorTest,
} from "pages";

import * as CommonBridge from "bridge/common/CommonBridge";

import { StarshopContainer, CSBoardContainer } from "containers";
import { modify } from "store/modules/common/loginReducer";
import { pedcCheck, changeMode } from "store/modules/common/settingReducer";
import { setIsAiPlayer } from "store/modules/common/aiReducer";
import { setAttendDone } from "store/modules/common/commonReducer";
import useRouteChangeTracker from "./store/customHooks/useRouteChangeTracker";
import useSpinner from "store/customHooks/useSpinner";

import { callPost, ConstantsServer } from "utils/CommonApi";
import { gethhmmss, getTodayDate } from "utils/DateUtil";
import { getRedisContext } from "utils/redisContext";
import RedirectComponent from "utils/RedirectComponent";
import { isDirectEntry, isDirectEntryUrl } from "utils/directEntry";

import Constants from "common/Constants";

import LnbWrapper from "components/lnb/LnbWrapper";
import { ExamPlanProvider } from "components/today/ExamPlan/ExamPlanContext";
import ExamPlanFloating from "components/today/ExamPlan/ExamPlanFloating";
import Popup from "./components/starshop/exchangeModal/ExchangeIndex";
import Gnb from "components/gnb/Gnb";
import LoadingSpinner from "components/common/Spinner";
import AllBackReportCard from "components/testLounge/allBackTest/AllBackReportCard";

import "./styles/common/font/nanumsquareround.css";
import "./styles/common/font/NanumSquareNeo/nanumsquareNeo.css";
import "styles";
import ToastMessage from "components/common/ToastMessage";

/**
 * 홈 개편(내신모드 UI 개편) 대상이 아닌 이용권.
 * 교문 집합형 심화 단과목(PEDC-00007 수학 / PEDC-00008 영어)만 신규 홈 대신 구 홈을 노출한다.
 * ('이용권별 플랫폼 및 권한 정의' 내신모드 > 개편대상 컬럼 기준)
 */
const LEGACY_HOME_PEDC = ["PEDC-00007", "PEDC-00008"];

/** 개발/검수용 화면은 dev·local 에서만 연다. (운영(real)에서는 라우트를 등록하지 않는다) */
const IS_DEV_ENV = ["dev", "local"].includes(String(process.env.REACT_APP_ENV).trim());

// 소켓 관련
const socketEndPoint = ConstantsServer.SERVER_DOMAIN.SOCKET_DOMAIN;
const socketExistRoute = [
    "/",
    "/today/middleStudyToday",
    "/today/allNewStudyToday", // 신규 홈 추가
    "/playerMain",
    "/online/OnlineLibraryBanner",
];

const confirmRoot = document.createElement("div");
const body = document.querySelector("body");
body.appendChild(confirmRoot);

export const AppContext = React.createContext({
    hideLNBToggleButton: () => {},
    showLNBToggleButton: () => {},
    platformType: null,
    curseType: null,
    isMobileApp: CommonBridge.checkIsMobileApp(),
    loadHandler: () => {},
    isLoad: false,

    setInfo: () => {},
    setPageInfo: () => {},
    setViewInfo: () => {},
});

/** 홈 경로. 신규 홈은 서랍이 꺼져 있어도 홈으로 본다. */
const HOME_PATH = "/today/middleStudyToday";
const ALL_NEW_HOME_PATH = "/today/allNewStudyToday";

const notGnb = [
    "/search/middleSearchMain",
    "/serviceMenu",
    "/playerMain",
    "/init/InitTimeTable",
    "/enrollSchoolCurriculumInfo",
    "/mypage/myAatb",
    "/pdfViewer",
    "/lounge/inqRpl/chat",
    "/lounge/inqRpl/inqWrite",
    "/guide/schedule",
    "/v",
    "/literatureBookReport/bookReportWrite",
    "/bookReportAnnouncement/myBookReport",
    "/bookReportAnnouncement/myBookReportDetail",
    "/bookReportAnnouncement/awardWinningWorkDetail",
    "/playerMainResultViewer",
    "/mystudy/studyAllTabNewFileUpload",
    "/mypage/myExamInfo",
    "/mypage/myExamScore",
];

const App = (props) => {
    useRouteChangeTracker();
    const dispatch = useDispatch();

    /* 세팅 정보 */
    const mmbrInfo = useSelector((state) => state.loginReducer);
    const mode = useSelector((state) => state.settingReducer.mode);
    const tmtblSetting = useSelector((state) => state.settingReducer.tmtblSetting);
    const pedcCheckDate = useSelector((state) => state.settingReducer.pedcCheckDate);
    const mmbrId = useSelector((state) => state.loginReducer.userId);
    const pedcCd = useSelector((state) => state.loginReducer.pedcCd);
    const loginInfo = useSelector((state) => state.loginReducer);
    const customerNumber = useSelector((state) => state.loginReducer.customerNumber);

    // 플랫폼 정보 (BookClub, StudyRoom, Default)
    const [platformType, setPlatformType] = useState(null);
    const [curseType, setCurseType] = useState(null);

    const currentUrl = useLocation();
    const [nowUrl, setNowUrl] = useState(null);
    const [firstUrl, setFirstUrl] = useState(null);

    let today = moment().format("YYYYMMDD");
    const [performanceTestPage, setPerformanceTestPage] = useState();

    // 과목 카드 로딩관련
    const [isLoad, setIsLoad] = useState(true);

    const [info, setInfo] = useState({});
    const [pageInfo, setPageInfo] = useState({
        size: null,
        pageIndex: null,
        filters: null,
    });

    const [viewInfo, setViewInfo] = useState(null);

    // LNB 관련
    const [isLnbActiveTab, setIsLnbActiveTab] = useState(false);
    const [isForceLnbActiveTab, setIsForceLnbActiveTab] = useState(false); // LNB 여닫기 상태

    // 온라인 독서실 관련
    const [onlineLibraryCnt, setOnlineLibraryCnt] = useState(3617);
    const [socket, setSocket] = useState(null);
    const [brcsStatus, setBrcsStatus] = useState(false);

    const history = useHistory();
    const location = useLocation();
    /** 홈 여부. 앱이 "/" 로 홈을 띄우는 경우가 있어 구 홈/신규 홈/루트를 모두 홈으로 본다. */
    const isHome = ["/", HOME_PATH, ALL_NEW_HOME_PATH].includes(location.pathname);
    const isMyExamDirectEntry =
        ["/mypage/myExamInfo", "/mypage/myExamScore"].includes(location.pathname) &&
        new URLSearchParams(location.search).has("MMBR_SEQ");

    const query = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    const { closeSpinner } = useSpinner();

    useEffect(() => {
        if (!isMyExamDirectEntry && loginInfo.mmbrSeq) {
            callBrcsInfo();
        }

        return forceDisconnectSocket;
    }, [isMyExamDirectEntry, loginInfo.mmbrSeq]);

    useEffect(() => {
        if (!loginInfo.mmbrSeq || !loginInfo.gradCd) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "user_info_update",
            user_id: String(loginInfo.mmbrSeq),
            user_grade: loginInfo.gradCd,
        });
    }, [loginInfo.mmbrSeq, loginInfo.gradCd]);

    // 자동로그인 되어 있는 휴지회원 체크 시 필요
    useEffect(() => {
        if (customerNumber) {
            localStorage.setItem("customerNumber", customerNumber);
        }
    }, [currentUrl, customerNumber]);

    useEffect(() => {
        if (socket) {
            console.log(socket);
            initSocketEvent();
        }
    }, [socket]);

    const forceDisconnectSocket = () => {
        if (socket) {
            socket.emit("forceDisconnect");
        }
    };

    const initSocketEvent = () => {
        window.connectOnlineStudyRoom = () => {};

        window.disconnectOnlineStudyRoom = () => {
            if (socket) {
                socket.emit("onlineLibraryDisconnect");
            }
        };

        socket.on("getCount", setOnlineLibraryCntWhenSocketEmitted);
    };

    // 0. 브릿지 설정
    useEffect(() => {
        window.callBridgeJs = CommonBridge;
    }, []);

    useEffect(() => {
        window.callNativeBackButton = () => {
            CommonBridge.callNativeBackButton();
        };
    }, [tmtblSetting]);

    useEffect(() => {
        window.setPlatform = (platformType) => {
            var parse = platformType.split(",");
            setPlatformType(parse[0]);
            if (parse.length > 1) {
                setCurseType(parse[1].trim());
            }
            /* 2022-10-06 교문집합형이면서 lnb 노출에 필요한 (curseType: ALL, NEASIN, SINGLE) 추가 */
        };
        CommonBridge.getPlatform();
    }, []);

    // 학습플레이어 로드 가능할 때 호출되는 함수
    useEffect(() => {
        CommonBridge.readyForStudy();
    }, []);

    useEffect(() => {
        // 하루에 한번 pedcCheck값 N으로 초기화, pedcCheckDate값 오늘날짜로 변경
        if (pedcCheckDate !== today) {
            dispatch(pedcCheck({ pedcCheckDate: today }));
        }
    }, [today]);

    // 2. 웹뷰 URL PAGE_TYPE이 T인 경우 (뒷배경 투명처리) 제외하고 body class값 추가
    useEffect(() => {
        if (getUrlParams.PAGE_TYPE !== "T") {
            if (mode) {
                document.body.classList.add("whiteMode_body");
            } else {
                document.body.classList.add("darkMode_body");
            }
        }
    }, ["darkMode_body", mode]);

    // 3. 집합형은 무조건 다크모드여야 한다.
    // 쿼리파람으로 MODE_TYPE 값 확인 후 리듀서에 설정 해주고 dartMode_body 값 변경한다.
    useEffect(() => {
        let queryModeInfo = getUrlParams.MODE_TYPE;
        if (queryModeInfo === "dark") {
            dispatch(changeMode({ mode: false }));
            document.body.classList.remove("whiteMode_body");
            document.body.classList.add("darkMode_body");
        }

        // 안드로이드에서 모드를 제어하기 위해 호출하는 함수
        // mode: dark, bright
        window.changeThemeMode = (theme) => {
            if (theme === "dark") {
                dispatch(changeMode({ mode: false }));
                document.body.classList.remove("whiteMode_body");
                document.body.classList.add("darkMode_body");

                return;
            }
            dispatch(changeMode({ mode: true }));
            document.body.classList.remove("darkMode_body");
            document.body.classList.add("whiteMode_body");
        };
    }, []);

    const getUrlParams = useMemo(() => {
        var params = {};
        window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
            params[key] = value;
        });
        return params;
    });

    useEffect(() => {
        closeSpinner();
    }, []);

    // 3. 현재 브라우저의 레디스 값 조회하여 (NODE API) 값이 있으면 로그인 처리

    let signedIn = useSelector((state) => state.loginReducer.signedIn);
    const defaultStatus = useSelector((state) => state);

    /**
     * 5. handleRoute는 컴포넌트 렌더시 props값을 내려주기 위해 셋팅
     * 5-1. 레디스 정보 확인
     * 5-2. 로그인 되어 있으면 메인화면(StudyToday)로, 되어있지 않으면 로그인 페이지로
     */
    useEffect(() => {
        // CMS 링크로 들어온 비로그인 조회 화면은 자동로그인을 시도하지 않는다.
        if (isDirectEntryUrl()) {
            return;
        }

        if (checkAutoLogin() || checkIsBrowserLogin()) {
            const callAutoLogin = (mmbrId, token) => {
                const param = {
                    MMBR_ID: mmbrId,
                    LOGIN_TOKEN: token,
                    URL: "/login/auto",
                    HTTP_METHOD: Constants.HTTP_METHOD.POST,
                    DOMAIN: ConstantsServer.SERVER_DOMAIN.SAMID_WEB_DOMAIN,
                };

                callPost({}, param, callbackDoLogin);
            };

            const callbackDoLogin = () => {
                console.log("자동로그인 완료");
            };

            getRedisContext(callAutoLogin);
            return;
        } else if (signedIn) {
            history.push("/logout");
        }
    }, []);

    const checkAutoLogin = () => {
        return !!window.localStorage.getItem("autoLogin");
    };

    const checkIsBrowserLogin = () => {
        return !!document.cookie.split("; ").find((row) => row.startsWith("SIGN_IN="));
    };

    /** 개편 대상이 아닌 이용권은 구 홈을 노출한다. */
    const isLegacyHomePedc = LEGACY_HOME_PEDC.includes(pedcCd);

    const renderHome = () => {
        if (isLegacyHomePedc) {
            return <StudyToday onlineLibraryCnt={onlineLibraryCnt} />;
        }

        return <AllNewStudyToday onlineLibraryCnt={onlineLibraryCnt} />;
    };

    const handleRoute = () => {
        if (!signedIn) {
            return <Login />;
        } else if (isLegacyHomePedc) {
            return <StudyToday onlineLibraryCnt={onlineLibraryCnt} />;
        } else {
            return <AllNewStudyToday onlineLibraryCnt={onlineLibraryCnt} {...defaultStatus} />;
        }
    };

    const callAttend = () => {
        if (loginInfo.mmbrSeq) {
            const headerParam = {
                user_id: loginInfo.userId,
            };

            const queryParam = {
                MMBR_SEQ: loginInfo.mmbrSeq,
            };
            const param = {
                REQUEST_API: Constants.ATTEND_API.ATTEND,
                HTTP_METHOD: Constants.HTTP_METHOD.PUT,
            };

            callPost(headerParam, param, callbackAttend, queryParam);
        }
    };

    const callbackAttend = (resData) => {
        const result = resData?.RESP_RESULT || resData;

        dispatch(setAttendDone(result?.SUCCESS_YN === "Y"));
    };

    useEffect(() => {
        if (!isMyExamDirectEntry && currentUrl && loginInfo.mmbrSeq) {
            callAttend();
        }
    }, [currentUrl, isMyExamDirectEntry, loginInfo.mmbrSeq]);

    useEffect(() => {
        return history.listen((location, action) => {
            try {
                if (nowUrl !== location.pathname + location.search) {
                    setNowUrl(location.pathname + location.search);
                }
            } catch (e) {
                console.error("[DEBUG]", e);
            }
        });
    }, [history]);

    const saveHistoryInfo = () => {
        if (!isMyExamDirectEntry && loginInfo?.mmbrSeq) {
            const headerParam = {
                user_id: mmbrId,
            };

            const queryParam = {
                MMBR_SEQ: loginInfo.mmbrSeq,
            };

            const body = qs.parse(location.search, { ignoreQueryPrefix: true });
            body.URLADR = nowUrl;

            const param = {
                REQUEST_API: Constants.HISTORY_API.SAVE_MENU_CONNECT_RECORD,
                HTTP_METHOD: Constants.HTTP_METHOD.POST,
                BODY: body,
            };

            callPost(headerParam, param, null, queryParam);
        }
    };

    useEffect(() => {
        saveHistoryInfo();
        showLNBToggleButton();
    }, [nowUrl]);

    useEffect(() => {
        if (brcsStatus && nowUrl && socketExistRoute.indexOf(nowUrl.split("?")[0]) > -1 && !socket) {
            setSocket(io(socketEndPoint));
        }
        if (brcsStatus && nowUrl && socket) {
            handleConnectSocket();
        }
    }, [nowUrl, socket, brcsStatus]);

    const setOnlineLibraryCntWhenSocketEmitted = (data) => {
        setOnlineLibraryCnt(data);
    };

    const handleConnectSocket = () => {
        if (socketExistRoute.indexOf(nowUrl.split("?")[0]) > -1) {
            socket.off("getCount");
            socket.on("getCount", setOnlineLibraryCntWhenSocketEmitted);
        }

        if (nowUrl === "/online/OnlineLibraryBanner") {
            socket.emit("onlineLibraryConnect", mmbrInfo);
        }
    };

    // 중복 처리 방지
    useEffect(() => {
        if (nowUrl !== currentUrl.pathname) {
            setNowUrl(currentUrl.pathname);
        }
        if (firstUrl === null) {
            setFirstUrl(currentUrl.pathname + currentUrl.search);
        }
    }, []);

    const showLNBToggleButton = () => {
        if (nowUrl !== "/testzone") {
            setIsForceLnbActiveTab(false);
        }
    };

    const hideLNBToggleButton = () => {
        setIsForceLnbActiveTab(true);
    };

    const loadHandler = (type) => {
        setIsLoad(type);
        return { result: isLoad };
    };

    const setInfoHandler = (value) => {
        setInfo(value);
    };

    const setPageInfoHandler = ({ size, pageIndex, filters = null }) => {
        setPageInfo({ size, pageIndex, filters });
    };

    const setViewInfoHandler = useCallback(
        (obj = null) => {
            if (!obj) {
                setViewInfo(obj);
                return null;
            }

            setViewInfo({
                ...viewInfo,
                ...obj,
            });
        },
        [viewInfo],
    );

    const appHandlers = useMemo(
        () => ({
            showLNBToggleButton,
            hideLNBToggleButton,
            platformType,
            loadHandler,
            isLoad,
            setInfoHandler,
            pageInfo,
            setPageInfoHandler,
            viewInfo,
            setViewInfoHandler,
        }),
        [showLNBToggleButton, hideLNBToggleButton, platformType, curseType, isLoad, info, pageInfo],
    );

    const callBrcsInfo = () => {
        const headerParam = {
            user_id: loginInfo.userId,
        };

        let queryParam = {
            MMBR_SEQ: loginInfo.mmbrSeq,
        };
        const param = {
            REQUEST_API: Constants.BRCS_API.BRCS_INFO,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };
        callPost(headerParam, param, callbackBrcsInfo, queryParam);
    };

    const callbackBrcsInfo = (resData) => {
        const today = getTodayDate();
        const nowTm = parseInt(gethhmmss());

        if (resData.RESP_RESULT.BRCS_INFO) {
            const onlineBrcsDt = resData.RESP_RESULT.BRCS_INFO.BRCS_DT;
            const onlineStartTm = parseInt(resData.RESP_RESULT.BRCS_INFO.STD_START_TM);
            const onlineEndTm = parseInt(resData.RESP_RESULT.BRCS_INFO.STD_END_TM);

            if (onlineStartTm <= nowTm && nowTm < onlineEndTm && today == onlineBrcsDt) {
                setBrcsStatus(true);
            }
        }
    };

    useEffect(() => {
        if (location.pathname !== "/aime" && location.pathname !== "/playerMain" && location.pathname !== "/aiEng") {
            localStorage.removeItem("activeEngmByPlayer");
            localStorage.removeItem("aiEngNav");
            localStorage.removeItem("aiEngRegularMainTab");
            localStorage.removeItem("aiEngRegularSubTab");
            localStorage.removeItem("aiEngExamMainTab");
            localStorage.removeItem("aiEngExamSubTab");
        }

        if (
            (location.pathname === "/playerMain" && query.STD_TY_DVSN_CD !== "AI_EN_RUL_PPTST_STD") ||
            location.pathname === "/evaluationReport"
        ) {
            dispatch(setIsAiPlayer(true));
        } else if (location.pathname !== "/aime") {
            dispatch(setIsAiPlayer(false));
        }
    }, [location]);

    const getBrowserVersion = () => {
        const userAgent = navigator.userAgent;
        const isAOS = window.android || false; // AOS

        const isMobileApp = CommonBridge.checkIsMobileApp();

        let APP_VERSION = "";
        let APP_PACKAGE_ID = "";
        let OS_TYPE = "";

        if (isMobileApp) {
            // APP
            if (isAOS) {
                let chromeVersion = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
                if (chromeVersion) {
                    APP_PACKAGE_ID = "chrome";
                    APP_VERSION = chromeVersion[1];
                    OS_TYPE = "AOS";
                }
            } else {
                let safariVersion = userAgent.match(/Safari\/([\d.]+)/);
                if (safariVersion) {
                    APP_PACKAGE_ID = "safari";
                    APP_VERSION = safariVersion[1];
                    OS_TYPE = "IOS";
                }
            }
        } else {
            // PC
            if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1) {
                let chromeVersion = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
                if (chromeVersion) {
                    APP_PACKAGE_ID = "chrome";
                    APP_VERSION = chromeVersion[1];
                    OS_TYPE = "WIN";
                }
            } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
                let safariVersion = userAgent.match(/Safari\/([\d.]+)/);
                if (safariVersion) {
                    APP_PACKAGE_ID = "safari";
                    APP_VERSION = safariVersion[1];
                    OS_TYPE = "IOS";
                }
            }
        }

        localStorage.setItem("APP_VERSION", APP_VERSION);
        localStorage.setItem("APP_PACKAGE_ID", APP_PACKAGE_ID);
        localStorage.setItem("OS_TYPE", OS_TYPE);
    };

    useEffect(() => {
        getBrowserVersion();
    }, []);

    // AIME 메뉴 기억
    useEffect(() => {
        const currentUrl = window.location.href;
        const isAime = currentUrl.includes("/aime?UP_MENU_CD=AISTUDY&MENU_CD=MATH&FROM_CD=TPMN");
        const isAiPlayer = currentUrl.includes("/AiPlayer");
        const isEvaluationReport = currentUrl.includes("/evaluationReport");
        const classView = currentUrl.includes("/classDetail");
        const playerView = currentUrl.includes("/playerMain");
        const evaluationPage = currentUrl.includes("/curriculum");

        if (isAime || isAiPlayer || isEvaluationReport || classView || playerView || evaluationPage) {
            console.log("AI 메뉴 진입");
        } else {
            localStorage.removeItem("testPeriod");
            localStorage.removeItem("aiMathTab");
            localStorage.removeItem("aiMathSubTab");
            localStorage.removeItem("aiMathGrade");
            localStorage.removeItem("aiMathSmst");
        }
    }, [location]);

    return (
        <AppContext.Provider value={appHandlers}>
            <Suspense fallback={<></>}>
                {signedIn && !isMyExamDirectEntry ? (
                    <ExamPlanProvider>
                        <Gnb
                            hasGnb={notGnb.indexOf(location.pathname) === -1}
                            firstUrl={firstUrl}
                            platformType={platformType}
                            nowUrl={nowUrl}
                        />
                        <LnbWrapper
                            // 서랍 메뉴는 신규 홈 개편으로 삭제됐고, 개편 제외 이용권(구 홈 사용자)만 기존처럼 유지한다.
                            hasLnb={isLegacyHomePedc}
                            nowUrl={nowUrl}
                            pedcCd={pedcCd}
                            mmbrId={mmbrId}
                            mmbrSeq={loginInfo.mmbrSeq}
                            platformType={platformType}
                            curseType={curseType}
                            isLnbActiveTab={isLnbActiveTab}
                            setIsLnbActiveTab={setIsLnbActiveTab}
                            isForceLnbActiveTab={isForceLnbActiveTab}
                        >
                            <Switch>
                                <Route exact path="/" render={handleRoute} />
                                <Route exact path="/logout" component={Logout} />
                                <Route exact path="/main" component={Main} />
                                {/* 홈 : 기존 경로에 신규 홈을 렌더한다. (구 홈 대체, 개편 제외 이용권은 구 홈) */}
                                <Route exact path="/today/middleStudyToday" render={renderHome} />
                                {/* 신규 홈 원래 경로 - 이미 나간 링크가 있어 그대로 열어둔다. */}
                                <Route exact path="/today/allNewStudyToday" render={renderHome} />
                                {/* 구 홈 - 롤백/비교용으로만 남겨둔다. */}
                                <Route
                                    exact
                                    path="/today/legacyStudyToday"
                                    render={() => <StudyToday onlineLibraryCnt={onlineLibraryCnt} />}
                                />
                                {/* 신규 홈 학습카드 전체보기(개발/검수용) - 운영 미노출 */}
                                {IS_DEV_ENV && (
                                    <Route exact path="/today/allNewCardGallery" component={AllNewCardGallery} />
                                )}
                                <Route path="/smart/middleStudySmart" component={StudySmart} />
                                <Route path="/top/middleStudyTop" component={StudyTop} />
                                <Route path="/search/middleSearchMain" component={SearchMain} />
                                <Route path="/init/InitTimeTable" component={InitTimeTable} />
                                <Route path="/enrollSchoolCurriculumInfo" component={EnrollSchoolCurriculumInfo} />
                                <Route exact path="/mypage" component={Mypage} />
                                <Route path="/mypage/myInfo" component={MyInfo} />
                                <Route path="/mypage/myAatb" component={MyAatb} />
                                <Route path="/mypage/myNoti" component={MyNoti} />
                                <Route path="/mypage/myNote" component={MyNote} />
                                <Route path="/mypage/myCalendarChg" component={MyCalendarChg} />
                                <Route path="/mypage/myExamInfo" component={MyExamInfo} />
                                <Route path="/mypage/myExamScore" component={MyExamScore} />
                                <Route path="/mypage/classQna/list" component={MyQnaMain} />
                                <Route path="/mypage/classQna/detail" component={MyQnaDetail} />
                                <Route path="/mypage/classQna/write" component={MyQnaWrite} />
                                <Route path="/mystudy/studyPlan" component={MyStudyPlan} />
                                <Route path="/mystudy/studyState" component={MyStudyState} />
                                {/* 올탭 과외학습 메인 페이지 */}
                                <Route path="/mystudy/studyAllTab" component={MyStudyAllTab} />
                                <Route path="/mystudy/studyAllTabNewFileUpload" component={AllTabFileUpload} />
                                <Route path="/mystudy/allTabSchedule" component={MyAllTabSchedule} />
                                {/* 올탭 나의 과외 학습 계획 캘린더 */}
                                <Route path="/mystudy/studyClas" component={MyStudyClas} />
                                <Route path="/mystudy/clasReg" component={ClasRegTimeTable} />
                                <Route path="/mystudy/clasUpd" component={ClasUpdTimeTable} />
                                <Route exact path="/lounge/inqRpl" component={LugInqRpl} />
                                <Route path="/lounge/inqRpl/inqWrite" component={LugInqWrite} />
                                <Route path="/lounge/inqRpl/chat" component={LugChat} />
                                <Route path="/testzone" component={TestZone} /> {/* 테스트존 메인 */}
                                <Route path="/WrongAnswerNotes" component={WrongAnswerNotes} />
                                {/* 테스트존 오답노트 */}
                                <Route
                                    path="/playerMain"
                                    onlineLibraryCnt={onlineLibraryCnt}
                                    render={() => (
                                        <PlayerMain onlineLibraryCnt={onlineLibraryCnt} brcsStatus={brcsStatus} />
                                    )}
                                />
                                <Route exact path="/starshop" component={StarshopContainer} />
                                <Route path="/starshop/exchange" component={Popup} />
                                <Route path="/classDetail" component={ClassDetail} />
                                <Route path="/expDetail" component={ExpDetail} />
                                <Route
                                    path="/online/OnlineLibraryBanner"
                                    render={() => <OnlineLibraryBanner onlineLibraryCnt={onlineLibraryCnt} />}
                                />
                                <Route
                                    path="/v"
                                    render={() => <OnlineLibraryBanner onlineLibraryCnt={onlineLibraryCnt} />}
                                />
                                <Route exact path="/csboard" component={CSBoardContainer} />
                                <Route path="/specialClass/specialClassMain" component={SpecialClassMain} />
                                <Route path="/specialClass/specialClassSub" component={SpecialClassSub} />
                                <Route path="/schoolCourse/schoolCourseMain" component={SchoolCourseMain} />
                                <Route path="/schoolCourse/schoolCourseDetail" component={SchoolCourseDetail} />
                                <Route path="/licenseClass/licenseClassMain" component={LicenseClassMain} />
                                <Route path="/licenseClass/licenseClassSub" component={LicenseClassSub} />
                                <Route path="/liveQna" component={LiveQnaMain} />
                                <Route path="/referenceRoom" component={ReferenceRoom} />
                                <Route path="/allZip" component={AllZip} />
                                <Route path="/pdfViewer" component={PdfViewer} />
                                <Route path="/serviceMenu" component={ServiceMenu} />
                                <Route path="/aiSuggest/question" component={AiRecommendQuestion} />
                                {/* 영어 Voca 프로그램 */}
                                <Route path="/englishVoca/index" component={EnglishVocaMain} />
                                <Route path="/englishVoca/textbook" component={EnglishVocaTextbook} />
                                <Route path="/englishVoca/schedule" component={EnglishVocaSchedule} />
                                <Route path="/englishVoca/highSchoolVoca" component={HighSchoolVoca} />
                                <Route path="/englishVoca/basicVoca" component={BasicVoca} />
                                {/* 커리큘럼 */}
                                <Route path="/curriculum" component={Curriculum} />
                                <Route path="/evaluationReport" component={EvaluationReport} />
                                <Route path="/englishLibrary" component={EnglishLibrary} />
                                <Route path="/guide/schedule" component={ScheduleGuide} />
                                <Route path="/aiMe" component={AiMe} />
                                <Route path="/aiPlayer" component={AiPlayer} />
                                <Route path="/Studytest" component={Studytest} />
                                <Route path="/myevent/event" component={EventPop} /> {/* 집합형 이벤트 메뉴 */}
                                <Route path="/pdfTest" component={PdfTest} /> {/* 집합형 이벤트 메뉴 */}
                                <Route path="/studyMusic" component={StudyMusic} />
                                {/* 수행평가 */}
                                <Route path="/performExam/performExamMain" component={PerformExamMain} />
                                <Route path="/performExam/performExamDetail" component={PerformExamDetail} />
                                <Route path="/literatureLibrary" component={LiteratureLibrary} />
                                <Route path="/playerTest" component={PlayerTest} />
                                <Route path="/pdfViewerTest" component={PdfViewerTest} />
                                {/* 문학 독후감 대회 */}
                                <Route exact path="/literatureBookReport" component={LiteratureBookReport} />
                                <Route path="/literatureBookReport/bookReportWrite" component={BookReportWrite} />
                                <Route exact path="/bookReportAnnouncement" component={BookReportAnnouncement} />
                                <Route path="/bookReportAnnouncement/myBookReport" component={MyBookReport} />
                                <Route
                                    path="/bookReportAnnouncement/myBookReportDetail"
                                    component={MyBookReportDetail}
                                />
                                <Route
                                    path="/bookReportAnnouncement/awardWinningWorkDetail"
                                    component={AwardWinningWorkDetail}
                                />
                                {/* 모의고사 성적분석 리포트 */}
                                <Route path="/examReportCard" component={ExamReportCard} />
                                {/* TEST라운지 영수모의고사 성적우수자 시상*/}
                                <Route path="/excellentExamAnnouncement" component={ExcellentExamAnnouncement} />
                                {/* 성적우수장학생 페이지 */}
                                <Route path="/reward" component={Reward} />
                                {/* 성적우수장학생 신청 페이지 */}
                                <Route path="/apply" component={ApplyReward} />
                                {/*올탭과학 진단평가 성적표*/}
                                <Route path="/scienceEvaluationReport" component={ScienceEvaluationReport} />
                                {/* 올백TEST 월간 학습 분석 리포트 */}
                                <Route path="/allBackReportCard" component={AllBackReportCard} />
                                <Route
                                    path="/playerMainResultViewer"
                                    onlineLibraryCnt={10}
                                    render={() => <PlayerMain onlineLibraryCnt={10} brcsStatus={false} />}
                                />
                                <Route path="/alltabLearningMate" component={AlltabLearningMate} />
                                <Route path="/aiEng" component={AiMeEng} />
                                <Route path="/WiseMentorTest" component={WiseMentorTest} />
                                <Route component={NotFound} />
                            </Switch>
                        </LnbWrapper>
                        {/**
                         * 시험대비모드 플로팅 패널의 노출 조건은 서랍(LNB) 버튼과 완전히 같다.
                         * isLnbActiveTab 은 ToggleButton(서랍 버튼)의 렌더 조건과 동일한 값이라
                         * 이 값만 따르면 "서랍이 안 나오는 화면"에는 패널도 나오지 않는다.
                         * (경로/이용권/플랫폼/강제 숨김 조건이 모두 이 안에 들어 있다)
                         * isHome 은 노출 여부가 아니라 토글 모양과 열림 상태 저장에만 쓴다.
                         */}
                        <ExamPlanFloating isVisible={isLnbActiveTab || isHome} isHome={isHome} />
                    </ExamPlanProvider>
                ) : (
                    <Switch>
                        <Route exact path="/" component={Login} />
                        <Route exact path="/logout" component={Logout} />
                        <Route path="/find/findId" component={FindId} />
                        <Route path="/find/findPassword" component={FindPassword} />
                        <Route path="/guide/join" component={JoinGuide} />
                        <Route path="/examReportCard" component={ExamReportCard} />
                        <Route path="/evaluationReport" component={EvaluationReport} />
                        <Route path="/mypage/myExamInfo" component={MyExamInfo} />
                        <Route path="/mypage/myExamScore" component={MyExamScore} />
                        <Route path="/aiPlayer" component={AiPlayer} />
                        <Route path="/scienceEvaluationReport" component={ScienceEvaluationReport} />
                        <Route
                            path="/playerMainResultViewer"
                            onlineLibraryCnt={10}
                            render={() => <PlayerMain onlineLibraryCnt={10} brcsStatus={false} />}
                        />
                        <Route path="/allBackTest" component={RedirectComponent} />
                        <Route path="/transfer/midServiceTermInfo" component={MidServiceTermInfo} />
                        <Route path="/transfer/midTransferList" component={MidTransferList} />
                        <Route path="/transfer/midServiceResult" component={MidServiceResult} />
                        <Route component={NotFound} />
                    </Switch>
                )}
                <LoadingSpinner />
                <ToastMessage />
            </Suspense>
        </AppContext.Provider>
    );
};

export default App;
